export default function Gallery() {
  return null;
}
